export const HEADERS = {
    sku_type_code : "Product Category Code",
    sku_type_name : "Product Category",
    is_gst_exempted: "Is GST Exempted",
    product_isolation : "Isolation Category",
    load_type:"Load Type",
    created_by : "Created By" ,
    created_on : "Created On" ,
    modified_by : "Modified By",
    modified_on : "Modified On" ,
    actions : "Edit/Delete"
}

export const TITLES = {
    main_title : "Product Category",
    add_title : "Add  Product Category",
    edit_title:'Edit Product Category'
}

export const LABELS = {
    sku_type_name : 'Product Category',
    sku_type_code : 'Product Category Code',
    is_gst_exempted: 'Is GST Exempted',
    product_isolation : "Isolation Category",
    load_type:"Load Type"
}
export const PLACE_HOLDERS = {
    sku_type_name : 'Category Name',
    sku_type_code : 'Category Code',
    product_isolation : "Select Isolation Category",
    load_type:"Select Load Type"
}
export const BUTTONS = {
    submit : "Submit"
}

export const MESSAGES = {
    addSuccess: "Category added successfully",
    addFailure: "Failed to add Category",
    updateSuccess: "Category updated successfully",
    updateFailure: "Failed to update Category",
}